import { render, staticRenderFns } from "./ObjectDisplay.vue?vue&type=template&id=1335ee64&"
import script from "./ObjectDisplay.vue?vue&type=script&lang=js&"
export * from "./ObjectDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports